/* eslint-disable no-nested-ternary */
import PropTypes from "prop-types";
import RingChart from "@shared/v2/RingChart";
import { useIsPlace } from "../../reducers/layoutReducer/selectors";

const INACTIVE_COLOR = "#ECEFEF";
const GAP = 0.055;
const SEGMENT_ARC = (1 - 3 * GAP) / 3;

const LEVEL_CONFIG = {
  low: { count: 1, color: "#999999" },
  med: { count: 2, color: "#333333" },
  high: { count: 3, color: "#4CA7A7" },
  multi: { count: 3, color: "#4CA7A7" },
};

const LABEL_COLOR_CLASSES = {
  low: "tw-text-[#999999]",
  med: "tw-text-[#333333]",
  high: "tw-text-[#4CA7A7]",
  multi: "tw-text-[#4CA7A7]",
  highPlace: "tw-text-[#2E6CE5]",
};

const getChartData = (level, isPlace) => {
  const config = LEVEL_CONFIG[level];
  const count = config ? config.count : 0;
  let activeColor = INACTIVE_COLOR;
  if ((level === "high" || level === "multi") && isPlace) {
    activeColor = "#2E6CE5";
  } else if (config) {
    activeColor = config.color;
  }

  const seg1End = SEGMENT_ARC;
  const gap1End = seg1End + GAP;
  const seg2End = gap1End + SEGMENT_ARC;
  const gap2End = seg2End + GAP;
  const seg3End = gap2End + SEGMENT_ARC;

  return [
    { value: seg1End, color: count >= 1 ? activeColor : INACTIVE_COLOR },
    { value: gap1End, color: "transparent" },
    { value: seg2End, color: count >= 2 ? activeColor : INACTIVE_COLOR },
    { value: gap2End, color: "transparent" },
    { value: seg3End, color: count >= 3 ? activeColor : INACTIVE_COLOR },
  ];
};

const isMultiLevel = (level) => level != null && !Number.isNaN(Number(level));

const RemineDial = ({ level, size }) => {
  const isPlace = useIsPlace();
  const isNumericMulti = isMultiLevel(level);
  const isStringMulti = level === "multi";
  const isMulti = isNumericMulti || isStringMulti;
  const resolvedLevel = isMulti ? "multi" : level;
  const labelColorClass =
    (resolvedLevel === "high" || isMulti) && isPlace
      ? LABEL_COLOR_CLASSES.highPlace
      : LABEL_COLOR_CLASSES[resolvedLevel] || LABEL_COLOR_CLASSES.low;

  return (
    <div className="tw-inline-block tw-rotate-[9.9deg]">
      <RingChart
        size={size}
        strokeWidth={size * 0.1}
        data={getChartData(resolvedLevel, isPlace)}
        variant="segmented"
        strokeLinecap="round"
        baseColor="transparent"
      >
        <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-rotate-[-9.9deg]">
          {isNumericMulti ? (
            <div className={`tw-flex tw-flex-col tw-items-center ${labelColorClass}`}>
              <span className="tw-text-[11px] tw-font-bold tw-leading-[100%]">{Number(level)}</span>
              <span className="tw-text-[9px] tw-font-normal tw-leading-[100%] tw-text-gray-75">Scores</span>
            </div>
          ) : isStringMulti ? null : (
            <span className={`tw-text-[10px] tw-leading-[16px] tw-font-bold ${labelColorClass}`}>
              {level ? level.toUpperCase() : ""}
            </span>
          )}
        </div>
      </RingChart>
    </div>
  );
};

RemineDial.propTypes = {
  level: PropTypes.oneOfType([
    PropTypes.oneOf(["low", "med", "high", "multi"]),
    PropTypes.number,
    PropTypes.string,
  ]),
  size: PropTypes.number,
};

RemineDial.defaultProps = {
  level: 'low',
  size: 50,
};

export default RemineDial;
